import React from 'react';
import { Box, useTheme } from '@mui/material';

interface MedalProps {
    ranking?: number;
    borderColor?: string; // Optional custom border color
}

const getMedalStyle = (ranking: number | undefined, themeMode: 'light' | 'dark'): { backgroundColor: string; color: string } => {
    switch (ranking) {
        case 1:
            return { backgroundColor: '#FFD700', color: '#fff' }; // Gold
        case 2:
            return { backgroundColor: '#C0C0C0', color: '#fff' }; // Silver
        case 3:
            return { backgroundColor: '#CD7F32', color: '#fff' }; // Bronze
        default:
            return themeMode === 'dark'
                ? { backgroundColor: 'transparent', color: '#fff' } // Dark theme default
                : { backgroundColor: 'transparent', color: '#000' }; // Light theme default
    }
};

const transparentBorder = 'transparent';

const Medal: React.FC<MedalProps> = ({ ranking, borderColor = transparentBorder }) => {
    const theme = useTheme();
    const themeMode = theme.palette.mode; // Get the current theme mode ('light' or 'dark')
    const { backgroundColor, color } = getMedalStyle(ranking, themeMode);

    return (
        <Box
            sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor,
                color,
                border: !ranking || ranking <= 3 ? `1px solid ${borderColor}` : 'none', // Border only for medals
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontWeight: !ranking || ranking <= 3 ? 'bold' : 'normal',
                fontSize: '0.875rem',
                textAlign: 'center', // Ensure text alignment
            }}
        >
            {ranking}
        </Box>
    );
};

export default Medal;
